export const environment = {
  // domain: "http://localhost/api",
  domain: "http://localhost/api",
  // domain: "http://localhost/api",
  // domain: "http://192.168.0.104/api",
  serverName: "TEST",
}